import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { Loader } from '../../components/Loader';
import { useWikiCapabilityEnabled } from '../../hooks/useWikiCapabilityEnabled';
import { ROUTES } from '../consts';

type WikiCapabilityProtectedRouteProps = PropsWithChildren<{
  fallbackTo?: string;
}>;

/**
 * Guards the Wiki routes on the combined Wiki capability: the platform rollout
 * flag AND the workspace-level `wiki.enabled` config toggle. Mirrors
 * FeatureFlagProtectedRoute but blocks direct navigation when the workspace has
 * turned the Wiki off, so a bookmarked /wiki URL doesn't render.
 */
export const WikiCapabilityProtectedRoute = ({
  children,
  fallbackTo = ROUTES.ROOT,
}: WikiCapabilityProtectedRouteProps) => {
  const { canAccess, isLoading } = useWikiCapabilityEnabled();

  if (isLoading) {
    return <Loader center />;
  }

  if (!canAccess) {
    console.warn("You're not allowed to access this page");

    return <Navigate to={fallbackTo} replace />;
  }

  return <>{children}</>;
};
